module.exports = __webpack_public_path__ + "media/images/join-6-adf8aee7dd82625fada5e6ce5b0ff660.jpg";